/*
To use this confirmation modal utility, you simply have to add the class "requires-confirmation" to a clickable element on the page
    and provide the attribute data-confirmation-message attribute (e.g. data-confirmation-message="Are you sure you want to undo the termination on this stay?").

To confirm a GET link, create an MVC link like normal and add the pieces references above. The utility will pick up the GET url from the rendered Razor code.

To confirm a POST form, create a form element with the appropriate data fields, action and method. Add a data-form-selector attribute to your clickable element
    that would select the form to be posted.

This utility will pick up the confirmation modal trigger you have defined and intercept the either normal MVC route or the form submission with a modal.
If the "Yes" option is selected, if a form selector is designated, the form will be submitted. Otherwise the MVC GET route will be followed.

The UpdateStay.cshtml page has an example of this utility being used for a POST form submission with the Undo Stay Termination process.
*/

import { Modal } from "bootstrap";
import { v4 as uuidv4 } from 'uuid';

const classIdentifier = 'requires-confirmation';
const configuredIdentifier = 'confirmation-configured';

export default {
    configureConfirmationModals
}

export function configureConfirmationModals() {
    $(`.${classIdentifier}`).not(`.${configuredIdentifier}`).each((i, e) => {
        $(e).on('click', function (e) {
            e.preventDefault();

            displayConfirmationModal(this.id, this.dataset.confirmationMessage, () => {
                // get confirmation action values
                const confirmationFormSelector = this.getAttribute('form') ? '#' + this.getAttribute('form') : this.dataset.formSelector;
                const confirmationUrl = $(this).attr('href');

                if (confirmationFormSelector) {
                    $(confirmationFormSelector).trigger('submit');
                } else {
                    window.location.href = confirmationUrl;
                }
            }, this.dataset.isHtml, this.dataset.callingElementId);

            return false;
        });
        $(e).addClass(configuredIdentifier);
    });
}

export function displayConfirmationModal(id: string, message: string, onConfirmHandler: Function, isHtml?: string, callingElementId?: string) {
    // setup modal variables from trigger
    const modalId = (id || uuidv4()) + '-confirmation';

    const modalElement = document.createElement('div');
    modalElement.id = modalId;
    modalElement.setAttribute('class', 'modal');
    modalElement.setAttribute('tabindex', '1');
    modalElement.innerHTML = `
<div class="modal-dialog">
<div class="modal-content">
<div class="modal-header">
<h5 class="modal-title">Confirmation</h5>
<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
</div>
<div class="modal-body">
<p></p>
</div>
<div class="modal-footer">
<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">No</button>
<button type="button" class="btn btn-primary confirmation-button">Yes</button>
</div>
</div>
</div>
`;
    document.body.appendChild(modalElement);

    setTimeout(() => {
        const confirmationModal = new Modal(modalElement);
        confirmationModal.show();

        if (isHtml === "true") {
            $(`#${modalId} p`).html(message);
        }
        else {
            $(`#${modalId} p`).text(message);
        }
    
        $(`#${modalId} .confirmation-button`).on('click', () => {
            if (onConfirmHandler) {
                onConfirmHandler(confirmationModal);
                confirmationModal.hide();
            }
        });
    }, 0);
    document.addEventListener('hidden.bs.modal', function () {
        if (callingElementId > "") {
            document.getElementById(callingElementId).focus();
        }
    });
}